<template>
  <div class="sidebar-wrapper" :class="{ 'is-collapse': collapse }">
    <div class="sidebar-logo">
      <span v-if="!collapse" class="logo-text">小游戏管理</span>
      <span v-else class="logo-text-mini">游戏</span>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="collapse"
        :background-color="'#304156'"
        :text-color="'#bfcbd9'"
        :active-text-color="'#409EFF'"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
        router
      >
        <template v-for="route in menuRoutes">
          <!-- 所有子菜单都隐藏：显示父级单菜单 -->
          <template v-if="getShowingChildren(route).length === 0">
            <el-menu-item :key="route.path" :index="route.path">
              <i :class="route.meta && route.meta.icon"></i>
              <span slot="title">{{ route.meta && route.meta.title }}</span>
              <sup v-if="shouldShowOrderUnread(route)" class="nav-unread-badge">{{ unreadBadgeText }}</sup>
            </el-menu-item>
          </template>

          <!-- 只有1个可见子菜单：扁平化显示 -->
          <template v-else-if="getShowingChildren(route).length === 1">
            <el-menu-item :key="route.path + '/' + getShowingChildren(route)[0].path" :index="route.path + '/' + getShowingChildren(route)[0].path">
              <i :class="getShowingChildren(route)[0].meta && getShowingChildren(route)[0].meta.icon"></i>
              <span slot="title">{{ getShowingChildren(route)[0].meta && getShowingChildren(route)[0].meta.title }}</span>
              <sup v-if="shouldShowOrderUnread(getShowingChildren(route)[0])" class="nav-unread-badge">{{ unreadBadgeText }}</sup>
            </el-menu-item>
          </template>

          <!-- 多个可见子菜单：显示子菜单 -->
          <el-submenu v-else :key="route.path" :index="route.path" popper-append-to-body>
            <template slot="title">
              <i :class="route.meta && route.meta.icon"></i>
              <span slot="title">{{ route.meta && route.meta.title }}</span>
              <sup v-if="shouldShowOrderUnread(route)" class="nav-unread-badge is-parent">{{ unreadBadgeText }}</sup>
            </template>
            <el-menu-item
              v-for="child in getShowingChildren(route)"
              :key="route.path + '/' + child.path"
              :index="route.path + '/' + child.path"
            >
              <i v-if="child.meta && child.meta.icon" :class="child.meta.icon"></i>
              <span slot="title">{{ child.meta && child.meta.title }}</span>
              <sup v-if="shouldShowOrderUnread(child)" class="nav-unread-badge">{{ unreadBadgeText }}</sup>
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { constantRoutes } from '@/router'

export default {
  name: 'Sidebar',
  props: {
    collapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    menuRoutes() {
      return constantRoutes.filter(route => !route.hidden)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    shopOrderUnreadCount() {
      return this.$store.state.shopOrder ? this.$store.state.shopOrder.unreadCount : 0
    },
    unreadBadgeText() {
      return String(this.shopOrderUnreadCount)
    }
  },
  created() {
    this.refreshOrderUnreadCount()
    this.orderUnreadTimer = window.setInterval(this.refreshOrderUnreadCount, 20000)
    window.addEventListener('focus', this.refreshOrderUnreadCount)
  },
  beforeDestroy() {
    window.clearInterval(this.orderUnreadTimer)
    window.removeEventListener('focus', this.refreshOrderUnreadCount)
  },
  methods: {
    getShowingChildren(route) {
      const children = route.children || []
      return children.filter(item => !item.hidden)
    },
    hasOneShowingChild(route) {
      return this.getShowingChildren(route).length <= 1
    },
    shouldShowOrderUnread(route) {
      return this.shopOrderUnreadCount > 0 && route &&
        (route.name === 'PointShopManage' || route.name === 'PointShopOrder')
    },
    refreshOrderUnreadCount() {
      this.$store.dispatch('shopOrder/refreshUnreadCount').catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  &.is-collapse {
    .sidebar-logo {
      text-align: center;
      .logo-text { display: none; }
      .logo-text-mini { display: inline; }
    }
  }
}

.sidebar-logo {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  .logo-text-mini { display: none; }
}

.nav-unread-badge {
  position: absolute;
  top: 50%;
  right: 16px;
  z-index: 2;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  box-sizing: border-box;
  transform: translateY(-50%);
  background: #f56c6c;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;

  &.is-parent {
    right: 34px;
  }
}

.sidebar-wrapper.is-collapse .nav-unread-badge {
  top: 7px;
  right: 5px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  transform: none;
  font-size: 10px;
  line-height: 16px;
}

::v-deep {
  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }
  .el-scrollbar__bar.is-horizontal {
    display: none;
  }
  .el-scrollbar {
    height: calc(100% - 50px);
  }
  .el-menu {
    border: none;
    width: 100% !important;
  }
}
</style>
